import { render } from "./SliderButtons.vue?vue&type=template&id=19ebabb2&scoped=true"
import script from "./SliderButtons.vue?vue&type=script&lang=js"
export * from "./SliderButtons.vue?vue&type=script&lang=js"

import "@/Common/Styles/sliderButtons.scss?vue&type=style&index=0&id=19ebabb2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ebabb2"]])

export default __exports__